import { moment } from '@eventbrite/date';
import { Badge } from '@eventbrite/eds-badge';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import './BrowseContainer.scss';

const HOMEPAGE_NEW_FOR_YOU_BADGE = 'eventbrite_homepage_for_you_badge';

export const ForYouTabKey: React.FunctionComponent = () => {
    const [shouldRenderNewBadge, setRenderNewBadge] = React.useState(false);

    React.useEffect(() => {
        const storedDate = window.localStorage.getItem(
            HOMEPAGE_NEW_FOR_YOU_BADGE,
        );

        if (storedDate && moment(storedDate).isAfter()) {
            setRenderNewBadge(true);
        } else {
            const isoStringThreeMonths = moment()
                .add(2, 'months')
                .toISOString();

            window.localStorage.setItem(
                HOMEPAGE_NEW_FOR_YOU_BADGE,
                isoStringThreeMonths,
            );

            setRenderNewBadge(true);
        }
    }, []);

    return shouldRenderNewBadge ? (
        <div style={{ position: 'relative', paddingRight: '24px' }}>
            {gettext('For you')}
            <span style={{ paddingLeft: '4px' }} />
            <div style={{ position: 'absolute', top: '-12px', right: '-12px' }}>
                <Badge text={gettext('New')} bgColor="success" />
            </div>
        </div>
    ) : (
        <span style={{ paddingRight: '12px' }}>{gettext('For you')}</span>
    );
};
